var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsRightLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6464 1.64645C10.8417 1.45118 11.1583 1.45118 11.3536 1.64645L14.3536 4.64645C14.4473 4.74022 14.5 4.86739 14.5 5C14.5 5.13261 14.4473 5.25979 14.3536 5.35355L11.3536 8.35355C11.1583 8.54882 10.8417 8.54882 10.6464 8.35355C10.4512 8.15829 10.4512 7.84171 10.6464 7.64645L12.7929 5.5L5 5.5C4.72386 5.5 4.5 5.27614 4.5 5C4.5 4.72386 4.72386 4.5 5 4.5L12.7929 4.5L10.6464 2.35355C10.4512 2.15829 10.4512 1.84171 10.6464 1.64645ZM5.35355 7.64645C5.54882 7.84171 5.54882 8.15829 5.35355 8.35355L3.20711 10.5H11C11.2761 10.5 11.5 10.7239 11.5 11C11.5 11.2761 11.2761 11.5 11 11.5H3.20711L5.35355 13.6464C5.54882 13.8417 5.54882 14.1583 5.35355 14.3536C5.15829 14.5488 4.84171 14.5488 4.64645 14.3536L1.64645 11.3536C1.45118 11.1583 1.45118 10.8417 1.64645 10.6464L4.64645 7.64645C4.84171 7.45118 5.15829 7.45118 5.35355 7.64645Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsRightLeft);
export default __webpack_public_path__ + "static/media/ArrowsRightLeft.2b9a09b18ad53f166084cb7d3de169d3.svg";
export { ForwardRef as ReactComponent };